<template>
  <v-row class="mt-1 mt-md-9">
    <!-- <v-breadcrumbs
      v-if="$vuetify.breakpoint.mdAndUp"
      :items="menus"
      class="pl-0 mt-6"
    /> -->
    <ChatMensagens />
    <ChatInfo />
  </v-row>
</template>

<script>
import ChatInfo from '@/components/Chat/ChatInfo.vue';
import ChatMensagens from '@/components/Chat/ChatMensagens.vue';
// import { mapState } from 'vuex';

export default {
  name: 'ChatPrincipal',

  components: {
    ChatInfo,
    ChatMensagens,
  },

  // computed: {
  //   ...mapState(['dadosTransacao']),

  //   menus() {
  //     return [
  //       {
  //         text: 'Minhas Compras',
  //         disabled: false,
  //         href: '/minhas-compras/',
  //       },
  //       {
  //         text: 'Minhas Mensagens',
  //         disabled: true,
  //       },
  //       {
  //         text: this.dadosTransacao.parent_product_name,
  //         disabled: true,
  //       },
  //     ];
  //   },
  // },
};
</script>
